import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IConsTypeProductNature } from 'app/shared/model/cons-type-product-nature.model';
import { getEntities as getConsTypeProductNatures } from 'app/entities/cons-type-product-nature/cons-type-product-nature.reducer';
import { getEntity, updateEntity, createEntity, reset } from './met-product-nature.reducer';
import { IMetProductNature } from 'app/shared/model/met-product-nature.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Status } from 'app/shared/model/enumerations/status.model';

export const MetProductNatureUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const consTypeProductNatures = useAppSelector(state => state.consTypeProductNature.entities);
  const metProductNatureEntity = useAppSelector(state => state.metProductNature.entity);
  const loading = useAppSelector(state => state.metProductNature.loading);
  const updating = useAppSelector(state => state.metProductNature.updating);
  const updateSuccess = useAppSelector(state => state.metProductNature.updateSuccess);
  const statusValues = Object.keys(Status);
  const handleClose = () => {
    props.history.push('/met-product-nature');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getConsTypeProductNatures({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...metProductNatureEntity,
      ...values,
      typeProductNature: consTypeProductNatures.find(it => it.id.toString() === values.typeProductNature.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'ACTIVE',
          ...metProductNatureEntity,
          typeProductNature: metProductNatureEntity?.typeProductNature?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="almobadaraMasterDataApp.metProductNature.home.createOrEditLabel" data-cy="MetProductNatureCreateUpdateHeading">
            <Translate contentKey="almobadaraMasterDataApp.metProductNature.home.createOrEditLabel">
              Create or edit a MetProductNature
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="met-product-nature-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('almobadaraMasterDataApp.metProductNature.name')}
                id="met-product-nature-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.metProductNature.nameAr')}
                id="met-product-nature-nameAr"
                name="nameAr"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.metProductNature.nameEn')}
                id="met-product-nature-nameEn"
                name="nameEn"
                type="text"
              />
              <ValidatedField
                label={translate('almobadaraMasterDataApp.metProductNature.status')}
                id="met-product-nature-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {statusValues.map(status => (
                  <option value={status} key={status}>
                    {translate('almobadaraMasterDataApp.Status.' + status)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="met-product-nature-typeProductNature"
                name="typeProductNature"
                data-cy="typeProductNature"
                label={translate('almobadaraMasterDataApp.metProductNature.typeProductNature')}
                type="select"
              >
                <option value="" key="0" />
                {consTypeProductNatures
                  ? consTypeProductNatures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/met-product-nature" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MetProductNatureUpdate;
